import React, { useState } from "react";
import { IUserSmall } from "../../interfaces/IUser";
import { useGetProjectState } from "../../hooks/data/data_project";
import { useGetWorkerRate } from "../../hooks/data/data_dashboard";
import {
    Alert,
    Box,
    Checkbox,
    CircularProgress,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel,
    ListItemText,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import { SalesBoardUserNew } from "./SalesBoardUserNew";

interface IProps {
    userSmallArray: IUserSmall[];
}

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#FF8042", "#FF8042", "#FF8042", "#FF8042", "#FF8042"];

export const SalesDasboardNew: React.FC<IProps> = ({ userSmallArray }) => {
    const { projectStateArray, isLoadingProjectStateArray, refetchProjectState } = useGetProjectState();
    const [selectedUser, setSelectedUser] = useState<number[]>(() => {
        const stored = localStorage.getItem("selectedUser");
        return stored ? JSON.parse(stored) : [Number(localStorage.getItem("idUser"))];
    });
    const [showTeamChart, setShowTeamChart] = useState<boolean>(() => {
        const stored = localStorage.getItem("showTeamChart");
        return stored === null ? true : stored === "true";
    });

    const [showLeadChart, setShowLeadChart] = useState<boolean>(() => {
        const stored = localStorage.getItem("showLeadChart");
        return stored === null ? true : stored === "true";
    });
    //
    //
    const [fromDate, setFromDate] = useState<Date | null>(() => {
        let date = new Date();
        return new Date(date.getFullYear(), date.getMonth(), 1, 3);
    });
    const [toDate, setToDate] = useState<Date | null>(() => {
        let date = new Date();
        return new Date(date.getFullYear(), date.getMonth() + 1, 0, 3);
    });
    //
    const serachString =
        fromDate && toDate
            ? `from_date=${fromDate?.toISOString().split("T")[0]}&to_date=${toDate?.toISOString().split("T")[0]}`
            : fromDate
              ? `from_date=${fromDate?.toISOString().split("T")[0]}`
              : toDate
                ? `to_date=${toDate?.toISOString().split("T")[0]}`
                : undefined;
    //
    const { workerRareArray, isLoadingWorkRate } = useGetWorkerRate(serachString);

    const handleHideTeamChart = () => {
        setShowTeamChart(false);
        localStorage.setItem("showTeamChart", "false");
    };

    const handleShowTeamChart = () => {
        setShowTeamChart(true);
        localStorage.setItem("showTeamChart", "true");
    };
    const handleTeamChartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            handleShowTeamChart();
        } else {
            handleHideTeamChart();
        }
    };

    const handleRemoveUser = (userId: number) => {
        setSelectedUser((prev) => prev.filter((id) => id !== userId));
    };

    if (isLoadingProjectStateArray) {
        return <CircularProgress />;
    }
    if (!projectStateArray) {
        return <Alert severity="error">Ein Fehler ist aufgetretten!</Alert>;
    }
    return (
        <>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                <Typography variant="h5">Vertrieb</Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <FormControlLabel
                        control={<Checkbox checked={showTeamChart} onChange={handleTeamChartChange} size="small" />}
                        label="Gesamtes Team anzeigen"
                    />
                </Box>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={3}>
                    <TextField
                        label="Von"
                        value={fromDate === null ? "" : fromDate.toISOString().split("T")[0]}
                        type="date"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                            setFromDate(event.target.value === "" ? null : new Date(event.target.value))
                        }
                        fullWidth
                        size="small"
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        label="Bis"
                        value={toDate === null ? "" : toDate.toISOString().split("T")[0]}
                        type="date"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                            setToDate(event.target.value === "" ? null : new Date(event.target.value))
                        }
                        fullWidth
                        size="small"
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <InputLabel id="folder-label" shrink>
                            Mitarbeiter
                        </InputLabel>
                        <Select
                            labelId="folder-label"
                            placeholder="Mitarbeiter auswählen"
                            id="folder"
                            multiple
                            notched
                            label="Mitarbeiter"
                            value={selectedUser}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (value && typeof value !== "string") {
                                    setSelectedUser(value);
                                }
                            }}
                            renderValue={(selectedValues) =>
                                selectedValues
                                    .map((selectedValue) => {
                                        let user = userSmallArray.find((user) => user.id === selectedValue);
                                        return user ? `${user.first_name} ${user.last_name}` : "ERROR";
                                    })
                                    .join(", ")
                            }
                            size="small"
                            fullWidth
                        >
                            {userSmallArray
                                .filter((user) => user.profile !== null)
                                .filter((user) => [1, 3, 4, 5, 6].includes(user.profile!.Role))
                                .sort((a, b) =>
                                    `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`),
                                )
                                .map((user) => (
                                    <MenuItem key={`user-${user.id}`} value={user.id}>
                                        <Checkbox checked={selectedUser.includes(user.id)} />
                                        <ListItemText primary={`${user.first_name} ${user.last_name}`} />
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>

                {/*showTeamChart && (
                    /*
                    <SalesBoardUser
                        key="salesboard-user-all"
                        isTeam={true}
                        onHide={handleHideTeamChart}
                        logArray={logArray || []}
                        projectStateArray={projectStateArray || []}
                        projectSmallArray={projectSmallArray.results || []}
                        fromDate={fromDate}
                        toDate={toDate}
                    />
                    
                )*/}

                {isLoadingWorkRate ? (
                    <CircularProgress sx={{ m: 3 }} />
                ) : !workerRareArray ? (
                    <Alert severity="error">Fehler!</Alert>
                ) : (
                    (showTeamChart
                        ? [
                              {
                                  id: 0,
                                  first_name: "Ganzes",
                                  last_name: "Team",
                                  profile: {
                                      id: 0,
                                      Role: 4,
                                  },
                              } as IUserSmall,
                              ...userSmallArray,
                          ]
                        : userSmallArray
                    )

                        .filter((user) => user.profile !== null)
                        .filter((user) =>
                            showTeamChart
                                ? user.id === 0 || selectedUser.includes(user.id)
                                : selectedUser.includes(user.id),
                        )
                        .map((user) => (
                            <SalesBoardUserNew
                                key={`salesboard-user${user.id}`}
                                currentUserSamll={user}
                                workerRareArray={workerRareArray || []}
                                projectStateArray={projectStateArray || []}
                                fromDate={fromDate}
                                toDate={toDate}
                                onHide={() => handleRemoveUser(user.id)}
                            />
                        ))
                )}
            </Grid>

            <Box sx={{ mb: 10 }} />
        </>
    );
    return <></>;
};
